import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import PaymentChangeStatusButton from './forms/changeStatus/PaymentChangeStatusButton'
import { statusSupplyBillPaymentText } from '../../../../../helpers/status/StatusSupplyOrderHelper'
import SupplyBillPaymentButton from './forms/billPaymentForm/SupplyBillPaymentButton'

const SupplyBillPaymentItem = ({ supplyBillId, billPayment, index }) => {
  return (
	<TableRow>
        <TableCell align='center'>
            {
                billPayment.id
            }
        </TableCell>
        <TableCell align='center'>
            {
				billPayment.billNumber
			}
        </TableCell>
        <TableCell align='center'>
            {
				statusSupplyBillPaymentText[billPayment.type]
			}
        </TableCell>
        <TableCell align='center'>
            <div className='supplyAgrees supplyAgrees__center'>
                <PaymentChangeStatusButton 
                    billPayment={billPayment}
                />
            </div>
        </TableCell>
        <TableCell align="center" className='myTable__actions'>
            {/* <DeleteBillItemButton 
                supplyBillItem={supplyBillItem}
            /> */}
            <SupplyBillPaymentButton
                supplyBillId={supplyBillId}
                billPayment={billPayment}
            />
        </TableCell>
    </TableRow>
  )
}

export default SupplyBillPaymentItem